module.exports = __webpack_public_path__ + "static/fonts/Arita-buriSB.381b5bc.ttf";